import React from "react";
import styled from "styled-components";
import RetouchingImage from "../components/molecules/RetouchingImage";

// images
import skinOne from "../assets/images/retouching/skinOne.jpg";
import skinTwo from "../assets/images/retouching/skinTwo.jpg";
import skinThree from "../assets/images/retouching/skinThree.jpg";

import environmentOne from "../assets/images/retouching/environmentOne.jpg";
import environmentTwo from "../assets/images/retouching/environmentTwo.jpg";
import environmentThree from "../assets/images/retouching/environmentThree.jpg";

import creativeOne from "../assets/images/retouching/creativeOne.jpg";
import creativeTwo from "../assets/images/retouching/creativeTwo.jpg";
import creativeThree from "../assets/images/retouching/creativeThree.jpg";

// style
const StyledRetouchScreen = styled.main`
  min-height: 88vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    opacity: 0.2;
    font-size: 3rem;
  }
  .retouch {
    display: flex;
    margin: 1rem;
    flex-direction: column;
    .images {
      display: flex;
      flex-direction: column;
    }
    h2 {
      font-weight: 400;
      opacity: 0.6;
      font-size: 2rem;
    }
  }

  // 720
  @media screen and (min-width: 1366px) {
    .retouch {
      .images {
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
      }
    }
  }
`;

const BlogScreen = () => {
  return (
    <StyledRetouchScreen>
      <h1>Retouching</h1>
      <div className="retouch skin">
        <h2>Skin</h2>
        <div className="images">
          <RetouchingImage image={skinOne} />
          <RetouchingImage image={skinTwo} />
          <RetouchingImage image={skinThree} />
        </div>
      </div>
      <div className="retouch environment">
        <h2>Environment</h2>
        <div className="images">
          <RetouchingImage image={environmentOne} />
          <RetouchingImage image={environmentTwo} />
          <RetouchingImage image={environmentThree} />
        </div>
      </div>
      <div className="retouch creative">
        <h2>Creative</h2>
        <div className="images">
          <RetouchingImage image={creativeOne} />
          <RetouchingImage image={creativeTwo} />
          <RetouchingImage image={creativeThree} />
        </div>
      </div>
    </StyledRetouchScreen>
  );
};

export default BlogScreen;
